export const findOrganizationIndex1 = (access) => {
  if (access) {
    const organizationIndex = access.findIndex(
      (menu) => menu?.key_name === "Admin Manager"
    );
    return organizationIndex;
  }
  return -1;
};

export const getViewStatus1 = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex1(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasTrueAccess = submenu.role_access.some(
        (role) => role.view === true
      );
      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export const getUpdateStatus1 = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex1(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasTrueAccess = submenu.role_access.some(
        (role) => role.update === true
      );
      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export const getSubMenuName1 = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo?.data?.access) {
    try {
      const organizationIndex = findOrganizationIndex1(userInfo?.data?.access);

      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex]?.name;
      return submenu;
    } catch (error) {
      //console.log("Error retrieving view status:", error);
      return "";
    }
  }
  return "";
};

export const getMainMenuName1 = (userInfo, topMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo?.data?.access) {
    try {
      const organizationIndex = findOrganizationIndex1(userInfo?.data?.access);

      const topMenuName =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ]?.name;

      return topMenuName;
    } catch (error) {
      //console.log("Error retrieving view status:", error);
      return "";
    }
  }
  return "";
};
export const getAtleastOneBlue1 = (userInfo, topMenuIndex) => {
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex1(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const hasTrueAccess = topMenu.sub_menu.some((submenu) =>
        submenu.role_access.some((role) => role.view === true)
      );

      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};
export const findOrganizationIndex2 = (access) => {
  if (access) {
    const organizationIndex = access.findIndex(
      (menu) => menu?.key_name === "Access Manager"
    );
    return organizationIndex;
  }
  return -1;
};

export const getViewStatus2 = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex2(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasTrueAccess = submenu.role_access.some(
        (role) => role.view === true
      );
      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export const getUpdateStatus2 = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex2(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasTrueAccess = submenu.role_access.some(
        (role) => role.update === true
      );
      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export const getSubMenuName2 = (userInfo, topMenuIndex, subMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo?.data?.access) {
    try {
      const organizationIndex = findOrganizationIndex2(userInfo?.data?.access);

      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex]?.name;
      return submenu;
    } catch (error) {
      //console.log("Error retrieving view status:", error);
      return "";
    }
  }
  return "";
};

export const getMainMenuName2 = (userInfo, topMenuIndex) => {
  //console.log(userInfo);
  if (userInfo && userInfo?.data?.access) {
    try {
      const organizationIndex = findOrganizationIndex2(userInfo?.data?.access);

      const topMenuName =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ]?.name;

      return topMenuName;
    } catch (error) {
      //console.log("Error retrieving view status:", error);
      return "";
    }
  }
  return "";
};

export const getAtleastOneBlue2 = (userInfo, topMenuIndex) => {
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex2(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const hasTrueAccess = topMenu.sub_menu.some((submenu) =>
        submenu.role_access.some((role) => role.view === true)
      );

      return hasTrueAccess;
    } catch (error) {
      return false;
    }
  }
  return false;
};

export const getRoleTrue = (userInfo, topMenuIndex, subMenuIndex, key_name) => {
  //console.log(userInfo);
  if (userInfo && userInfo.data.access) {
    try {
      const organizationIndex = findOrganizationIndex2(userInfo?.data?.access);
      const topMenu =
        userInfo?.data?.access[organizationIndex].side_menu[0].top_menu[
          topMenuIndex
        ];
      const submenu = topMenu.sub_menu[subMenuIndex];
      const hasRoleName = submenu.role_access.some(
        (role) => role.key_name === key_name
      );
      return hasRoleName;
    } catch (error) {
      return false;
    }
  }
  return false;
};
